<template>
  <div
    class="
      relative
      flex flex-col
      min-w-0
      break-words
      bg-white
      w-full
      mb-6
      shadow-lg
      rounded
      bg-gray-200
    "
  >
    <div class="rounded-t mb-0 px-4 py-6 border-0 bg-white">
      <div class="flex flex-wrap items-center">
        <div class="relative w-full px-2 max-w-full flex-grow flex-1">
          <h3 class="text-base text-dark text-left">Bulk Staking</h3>
        </div>

        <a
          class="
            mr-2
            bg-gray-300
            p-2
            px-2
            rounded-full
            text-dark
            font-bold
            text-xs
            cursor-pointer
          "
          v-on:click="toggleTabs(1)"
          v-bind:class="{
            'text-emerald-600 bg-white': openTab !== 1,
            'text-white bg-bgbb-y': openTab === 1,
          }"
          >2 STAKES</a
        >

        <a
          class="
            mr-2
            bg-gray-300
            p-2
            px-2
            rounded-full
            text-dark
            font-bold
            text-xs
            cursor-pointer
          "
          v-on:click="toggleTabs(2)"
          v-bind:class="{
            'text-emerald-600 bg-white': openTab !== 2,
            'text-white bg-bgbb-y': openTab === 2,
          }"
          >3 STAKES</a
        >
        <a
          class="
            mr-2
            bg-gray-300
            p-2
            px-2
            rounded-full
            text-dark
            font-bold
            text-xs
            cursor-pointer
          "
          v-on:click="toggleTabs(3)"
          v-bind:class="{
            'text-emerald-600 bg-white': openTab !== 3,
            'text-white bg-bgbb-y': openTab === 3,
          }"
          >4 STAKES</a
        >
        <a
          class="
            mr-2
            bg-gray-300
            p-2
            px-2
            rounded-full
            text-dark
            font-bold
            text-xs
            cursor-pointer
          "
          v-on:click="toggleTabs(4)"
          v-bind:class="{
            'text-emerald-600 bg-white': openTab !== 4,
            'text-white bg-bgbb-y': openTab === 4,
          }"
          >5 STAKES</a
        >
        <a
          class="
            mr-2
            bg-gray-300
            p-2
            px-2
            rounded-full
            text-dark
            font-bold
            text-xs
            cursor-pointer
          "
          v-on:click="toggleTabs(5)"
          v-bind:class="{
            'text-emerald-600 bg-white': openTab !== 5,
            'text-white bg-bgbb-y': openTab === 5,
          }"
          >6 STAKES</a
        >
        <a
          class="
            mr-2
            bg-gray-300
            p-2
            px-2
            rounded-full
            text-dark
            font-bold
            text-xs
            cursor-pointer
          "
          v-on:click="toggleTabs(6)"
          v-bind:class="{
            'text-emerald-600 bg-white': openTab !== 6,
            'text-white bg-bgbb-y': openTab === 6,
          }"
          >7 STAKES</a
        >
        <a
          class="
            mr-2
            bg-gray-300
            p-2
            px-2
            rounded-full
            text-dark
            font-bold
            text-xs
            cursor-pointer
          "
          v-on:click="toggleTabs(7)"
          v-bind:class="{
            'text-emerald-600 bg-white': openTab !== 7,
            'text-white bg-bgbb-y': openTab === 7,
          }"
          >8 STAKES</a
        >
        <a
          class="
            mr-2
            bg-gray-300
            p-2
            px-2
            rounded-full
            text-dark
            font-bold
            text-xs
            cursor-pointer
          "
          v-on:click="toggleTabs(8)"
          v-bind:class="{
            'text-emerald-600 bg-white': openTab !== 8,
            'text-white bg-bgbb-y': openTab === 8,
          }"
          >9 STAKES</a
        >
      </div>
    </div>

    <!-- ============= BEGIN 2 STAKES ======================= -->

    <div v-bind:class="{ hidden: openTab !== 1, block: openTab === 1 }">
      <div class="block w-full overflow-x-auto">
        <!-- Projects table -->
        <table class="items-center w-full bg-transparent border-collapse">
          <br />
          <p class="text-center">Create your ultimate staking strategy</p>
          <br />

          <tbody>
            <tr>
              <th
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  whitespace-no-wrap
                  p-4
                  text-base text-left text-gray-500
                "
              >
                15,000 BGBB
              </th>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-center text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-calendar-alt text-base"> </i> 183 DAYS
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-clock text-base"> </i>
                  #1
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="fas fa-user-plus text-base"> </i>
                  0x000...000000
                </p>
              </td>

              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right
                "
              >
                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibold
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-bgbb-y
                    text-sm
                  "
                >
                  Adjust Stake
                </a>

                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibold
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-dark-bgbb100
                    text-sm
                  "
                >
                  Remove Stake
                </a>
              </td>
            </tr>

            <tr>
              <th
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  whitespace-no-wrap
                  p-4
                  text-base text-left text-gray-500
                "
              >
                15,000 BGBB
              </th>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-center text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-calendar-alt text-base"> </i> 365 DAYS
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-clock text-base"> </i>
                  #2
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="fas fa-user-plus text-base"> </i>
                  0x000...000000
                </p>
              </td>

              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right
                "
              >
                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibold
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-bgbb-y
                    text-sm
                  "
                >
                  Adjust Stake
                </a>

                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibold
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-dark-bgbb100
                    text-sm
                  "
                >
                  Remove Stake
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="flex flex-wrap text-center justify-center mt-8">
        <a
          href="#"
          target="_self"
          class="
            mb-6
            font-semibold
            text-white
            px-6
            py-4
            rounded
            outline-none
            focus:outline-none
            bg-dark-bgbb100
            text-sm
            container2
          "
        >
          Create 2 Regular Stakes
        </a>
      </div>
    </div>
    <!-- ============= END 2 STAKES ======================= -->

    <!-- ============= BEGIN 3 STAKES ======================= -->
    <div v-bind:class="{ hidden: openTab !== 2, block: openTab === 2 }">
      <div class="block w-full overflow-x-auto">
        <!-- Projects table -->
        <table class="items-center w-full bg-transparent border-collapse">
          <br />
          <p class="text-center">Create your ultimate staking strategy</p>
          <br />

          <tbody>
            <tr>
              <th
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  whitespace-no-wrap
                  p-4
                  text-base text-left text-gray-500
                "
              >
                10,000 BGBB
              </th>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-center text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-calendar-alt text-base"> </i> 123 DAYS
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-clock text-base"> </i>
                  #1
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="fas fa-user-plus text-base"> </i>
                  0x000...000000
                </p>
              </td>

              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right
                "
              >
                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibold
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-bgbb-y
                    text-sm
                  "
                >
                  Adjust Stake
                </a>

                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibold
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-dark-bgbb100
                    text-sm
                  "
                >
                  Remove Stake
                </a>
              </td>
            </tr>

            <tr>
              <th
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  whitespace-no-wrap
                  p-4
                  text-base text-left text-gray-500
                "
              >
                10,000 BGBB
              </th>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-center text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-calendar-alt text-base"> </i> 244 DAYS
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-clock text-base"> </i>
                  #2
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="fas fa-user-plus text-base"> </i>
                  0x000...000000
                </p>
              </td>

              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right
                "
              >
                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibold
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-bgbb-y
                    text-sm
                  "
                >
                  Adjust Stake
                </a>

                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibold
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-dark-bgbb100
                    text-sm
                  "
                >
                  Remove Stake
                </a>
              </td>
            </tr>

            <tr>
              <th
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  whitespace-no-wrap
                  p-4
                  text-base text-left text-gray-500
                "
              >
                10,000 BGBB
              </th>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-center text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-calendar-alt text-base"> </i> 365 DAYS
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-clock text-base"> </i>
                  #3
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="fas fa-user-plus text-base"> </i>
                  0x000...000000
                </p>
              </td>

              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right
                "
              >
                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibold
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-bgbb-y
                    text-sm
                  "
                >
                  Adjust Stake
                </a>

                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibold
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-dark-bgbb100
                    text-sm
                  "
                >
                  Remove Stake
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="flex flex-wrap text-center justify-center mt-8">
        <a
          href="#"
          target="_self"
          class="
            mb-6
            font-semibold
            text-white
            px-6
            py-4
            rounded
            outline-none
            focus:outline-none
            bg-dark-bgbb100
            text-sm
            container2
          "
        >
          Create 3 Regular Stakes
        </a>
      </div>
    </div>
    <!-- ============= END 3 STAKES ======================= -->

    <!-- ============= BEGIN 4 STAKES ======================= -->
    <div v-bind:class="{ hidden: openTab !== 3, block: openTab === 3 }">
      <div class="block w-full overflow-x-auto">
        <!-- Projects table -->
        <table class="items-center w-full bg-transparent border-collapse">
          <br />
          <p class="text-center">Create your ultimate staking strategy</p>
          <br />

          <tbody>
            <tr>
              <th
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  whitespace-no-wrap
                  p-4
                  text-base text-left text-gray-500
                "
              >
                7,500 BGBB
              </th>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-center text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-calendar-alt text-base"> </i> 92 DAYS
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-clock text-base"> </i>
                  #1
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="fas fa-user-plus text-base"> </i>
                  0x000...000000
                </p>
              </td>

              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right
                "
              >
                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-bgbb-y
                    text-sm
                  "
                >
                  Adjust Stake
                </a>

                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-dark-bgbb100
                    text-sm
                  "
                >
                  Remove Stake
                </a>
              </td>
            </tr>

            <tr>
              <th
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  whitespace-no-wrap
                  p-4
                  text-base text-left text-gray-500
                "
              >
                7,500 BGBB
              </th>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-center text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-calendar-alt text-base"> </i> 183 DAYS
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-clock text-base"> </i>
                  #2
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="fas fa-user-plus text-base"> </i>
                  0x000...000000
                </p>
              </td>

              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right
                "
              >
                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-bgbb-y
                    text-sm
                  "
                >
                  Adjust Stake
                </a>

                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-dark-bgbb100
                    text-sm
                  "
                >
                  Remove Stake
                </a>
              </td>
            </tr>

            <tr>
              <th
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  whitespace-no-wrap
                  p-4
                  text-base text-left text-gray-500
                "
              >
                7,500 BGBB
              </th>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-center text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-calendar-alt text-base"> </i> 274 DAYS
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-clock text-base"> </i>
                  #3
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="fas fa-user-plus text-base"> </i>
                  0x000...000000
                </p>
              </td>

              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right
                "
              >
                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-bgbb-y
                    text-sm
                  "
                >
                  Adjust Stake
                </a>

                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-dark-bgbb100
                    text-sm
                  "
                >
                  Remove Stake
                </a>
              </td>
            </tr>

            <tr>
              <th
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  whitespace-no-wrap
                  p-4
                  text-base text-left text-gray-500
                "
              >
                7,500 BGBB
              </th>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-center text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-calendar-alt text-base"> </i> 365 DAYS
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-clock text-base"> </i>
                  #4
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="fas fa-user-plus text-base"> </i>
                  0x000...000000
                </p>
              </td>

              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right
                "
              >
                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-bgbb-y
                    text-sm
                  "
                >
                  Adjust Stake
                </a>

                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-dark-bgbb100
                    text-sm
                  "
                >
                  Remove Stake
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="flex flex-wrap text-center justify-center mt-8">
        <a
          href="#"
          target="_self"
          class="
            mb-6
            font-semibold
            text-white
            px-6
            py-4
            rounded
            outline-none
            focus:outline-none
            bg-dark-bgbb100
            text-sm
            container2
          "
        >
          Create 4 Regular Stakes
        </a>
      </div>
    </div>
    <!-- ============= END 4 STAKES ======================= -->

    <!-- ============= BEGIN 5 STAKES ======================= -->
    <div v-bind:class="{ hidden: openTab !== 4, block: openTab === 4 }">
      <div class="block w-full overflow-x-auto">
        <!-- Projects table -->
        <table class="items-center w-full bg-transparent border-collapse">
          <br />
          <p class="text-center">Create your ultimate staking strategy</p>
          <br />

          <tbody>
            <tr>
              <th
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  whitespace-no-wrap
                  p-4
                  text-base text-left text-gray-500
                "
              >
                6,000 BGBB
              </th>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-center text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-calendar-alt text-base"> </i> 73 DAYS
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-clock text-base"> </i>
                  #1
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="fas fa-user-plus text-base"> </i>
                  0x000...000000
                </p>
              </td>

              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right
                "
              >
                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-bgbb-y
                    text-sm
                  "
                >
                  Adjust Stake
                </a>

                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-dark-bgbb100
                    text-sm
                  "
                >
                  Remove Stake
                </a>
              </td>
            </tr>

            <tr>
              <th
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  whitespace-no-wrap
                  p-4
                  text-base text-left text-gray-500
                "
              >
                6,000 BGBB
              </th>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-center text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-calendar-alt text-base"> </i> 146 DAYS
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-clock text-base"> </i>
                  #2
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="fas fa-user-plus text-base"> </i>
                  0x000...000000
                </p>
              </td>

              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right
                "
              >
                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-bgbb-y
                    text-sm
                  "
                >
                  Adjust Stake
                </a>

                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-dark-bgbb100
                    text-sm
                  "
                >
                  Remove Stake
                </a>
              </td>
            </tr>

            <tr>
              <th
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  whitespace-no-wrap
                  p-4
                  text-base text-left text-gray-500
                "
              >
                6,000 BGBB
              </th>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-center text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-calendar-alt text-base"> </i> 219 DAYS
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-clock text-base"> </i>
                  #3
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="fas fa-user-plus text-base"> </i>
                  0x000...000000
                </p>
              </td>

              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right
                "
              >
                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-bgbb-y
                    text-sm
                  "
                >
                  Adjust Stake
                </a>

                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-dark-bgbb100
                    text-sm
                  "
                >
                  Remove Stake
                </a>
              </td>
            </tr>

            <tr>
              <th
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  whitespace-no-wrap
                  p-4
                  text-base text-left text-gray-500
                "
              >
                6,000 BGBB
              </th>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-center text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-calendar-alt text-base"> </i> 292 DAYS
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-clock text-base"> </i>
                  #4
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="fas fa-user-plus text-base"> </i>
                  0x000...000000
                </p>
              </td>

              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right
                "
              >
                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-bgbb-y
                    text-sm
                  "
                >
                  Adjust Stake
                </a>

                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-dark-bgbb100
                    text-sm
                  "
                >
                  Remove Stake
                </a>
              </td>
            </tr>

            <tr>
              <th
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  whitespace-no-wrap
                  p-4
                  text-base text-left text-gray-500
                "
              >
                6,000 BGBB
              </th>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-center text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-calendar-alt text-base"> </i> 365 DAYS
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-clock text-base"> </i>
                  #5
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="fas fa-user-plus text-base"> </i>
                  0x000...000000
                </p>
              </td>

              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right
                "
              >
                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-bgbb-y
                    text-sm
                  "
                >
                  Adjust Stake
                </a>

                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-dark-bgbb100
                    text-sm
                  "
                >
                  Remove Stake
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="flex flex-wrap text-center justify-center mt-8">
        <a
          href="#"
          target="_self"
          class="
            mb-6
            font-semibold
            text-white
            px-6
            py-4
            rounded
            outline-none
            focus:outline-none
            bg-dark-bgbb100
            text-sm
            container2
          "
        >
          Create 5 Regular Stakes
        </a>
      </div>
    </div>
    <!-- ============= END 5 STAKES ======================= -->

    <!-- ============= BEGIN 6 STAKES ======================= -->
    <div v-bind:class="{ hidden: openTab !== 5, block: openTab === 5 }">
      <div class="block w-full overflow-x-auto">
        <!-- Projects table -->
        <table class="items-center w-full bg-transparent border-collapse">
          <br />
          <p class="text-center">Create your ultimate staking strategy</p>
          <br />

          <tbody>
            <tr>
              <th
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  whitespace-no-wrap
                  p-4
                  text-base text-left text-gray-500
                "
              >
                5,000 BGBB
              </th>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-center text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-calendar-alt text-base"> </i> 65 DAYS
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-clock text-base"> </i>
                  #1
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="fas fa-user-plus text-base"> </i>
                  0x000...000000
                </p>
              </td>

              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right
                "
              >
                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-bgbb-y
                    text-sm
                  "
                >
                  Adjust Stake
                </a>

                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-dark-bgbb100
                    text-sm
                  "
                >
                  Remove Stake
                </a>
              </td>
            </tr>

            <tr>
              <th
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  whitespace-no-wrap
                  p-4
                  text-base text-left text-gray-500
                "
              >
                5,000 BGBB
              </th>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-center text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-calendar-alt text-base"> </i> 125 DAYS
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-clock text-base"> </i>
                  #2
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="fas fa-user-plus text-base"> </i>
                  0x000...000000
                </p>
              </td>

              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right
                "
              >
                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-bgbb-y
                    text-sm
                  "
                >
                  Adjust Stake
                </a>

                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-dark-bgbb100
                    text-sm
                  "
                >
                  Remove Stake
                </a>
              </td>
            </tr>

            <tr>
              <th
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  whitespace-no-wrap
                  p-4
                  text-base text-left text-gray-500
                "
              >
                5,000 BGBB
              </th>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-center text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-calendar-alt text-base"> </i> 185 DAYS
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-clock text-base"> </i>
                  #3
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="fas fa-user-plus text-base"> </i>
                  0x000...000000
                </p>
              </td>

              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right
                "
              >
                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-bgbb-y
                    text-sm
                  "
                >
                  Adjust Stake
                </a>

                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-dark-bgbb100
                    text-sm
                  "
                >
                  Remove Stake
                </a>
              </td>
            </tr>

            <tr>
              <th
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  whitespace-no-wrap
                  p-4
                  text-base text-left text-gray-500
                "
              >
                5,000 BGBB
              </th>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-center text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-calendar-alt text-base"> </i> 245 DAYS
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-clock text-base"> </i>
                  #4
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="fas fa-user-plus text-base"> </i>
                  0x000...000000
                </p>
              </td>

              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right
                "
              >
                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-bgbb-y
                    text-sm
                  "
                >
                  Adjust Stake
                </a>

                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-dark-bgbb100
                    text-sm
                  "
                >
                  Remove Stake
                </a>
              </td>
            </tr>

            <tr>
              <th
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  whitespace-no-wrap
                  p-4
                  text-base text-left text-gray-500
                "
              >
                5,000 BGBB
              </th>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-center text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-calendar-alt text-base"> </i> 305 DAYS
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-clock text-base"> </i>
                  #5
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="fas fa-user-plus text-base"> </i>
                  0x000...000000
                </p>
              </td>

              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right
                "
              >
                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-bgbb-y
                    text-sm
                  "
                >
                  Adjust Stake
                </a>

                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-dark-bgbb100
                    text-sm
                  "
                >
                  Remove Stake
                </a>
              </td>
            </tr>

            <tr>
              <th
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  whitespace-no-wrap
                  p-4
                  text-base text-left text-gray-500
                "
              >
                5,000 BGBB
              </th>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-center text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-calendar-alt text-base"> </i> 365 DAYS
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-clock text-base"> </i>
                  #6
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="fas fa-user-plus text-base"> </i>
                  0x000...000000
                </p>
              </td>

              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right
                "
              >
                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-bgbb-y
                    text-sm
                  "
                >
                  Adjust Stake
                </a>

                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-dark-bgbb100
                    text-sm
                  "
                >
                  Remove Stake
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="flex flex-wrap text-center justify-center mt-8">
        <a
          href="#"
          target="_self"
          class="
            mb-6
            font-semibold
            text-white
            px-6
            py-4
            rounded
            outline-none
            focus:outline-none
            bg-dark-bgbb100
            text-sm
            container2
          "
        >
          Create 6 Regular Stakes
        </a>
      </div>
    </div>
    <!-- ============= END 6 STAKES ======================= -->

    <!-- ============= BEGIN 7 STAKES ======================= -->
    <div v-bind:class="{ hidden: openTab !== 6, block: openTab === 6 }">
      <div class="block w-full overflow-x-auto">
        <!-- Projects table -->
        <table class="items-center w-full bg-transparent border-collapse">
          <br />
          <p class="text-center">Create your ultimate staking strategy</p>
          <br />

          <tbody>
            <tr>
              <th
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  whitespace-no-wrap
                  p-4
                  text-base text-left text-gray-500
                "
              >
                4,2857.71 BGBB
              </th>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-center text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-calendar-alt text-base"> </i> 53 DAYS
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-clock text-base"> </i>
                  #1
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="fas fa-user-plus text-base"> </i>
                  0x000...000000
                </p>
              </td>

              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right
                "
              >
                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-bgbb-y
                    text-sm
                  "
                >
                  Adjust Stake
                </a>

                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-dark-bgbb100
                    text-sm
                  "
                >
                  Remove Stake
                </a>
              </td>
            </tr>

            <tr>
              <th
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  whitespace-no-wrap
                  p-4
                  text-base text-left text-gray-500
                "
              >
                4,2857.71 BGBB
              </th>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-center text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-calendar-alt text-base"> </i> 105 DAYS
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-clock text-base"> </i>
                  #2
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="fas fa-user-plus text-base"> </i>
                  0x000...000000
                </p>
              </td>

              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right
                "
              >
                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-bgbb-y
                    text-sm
                  "
                >
                  Adjust Stake
                </a>

                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-dark-bgbb100
                    text-sm
                  "
                >
                  Remove Stake
                </a>
              </td>
            </tr>

            <tr>
              <th
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  whitespace-no-wrap
                  p-4
                  text-base text-left text-gray-500
                "
              >
                4,2857.71 BGBB
              </th>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-center text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-calendar-alt text-base"> </i> 157 DAYS
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-clock text-base"> </i>
                  #3
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="fas fa-user-plus text-base"> </i>
                  0x000...000000
                </p>
              </td>

              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right
                "
              >
                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-bgbb-y
                    text-sm
                  "
                >
                  Adjust Stake
                </a>

                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-dark-bgbb100
                    text-sm
                  "
                >
                  Remove Stake
                </a>
              </td>
            </tr>

            <tr>
              <th
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  whitespace-no-wrap
                  p-4
                  text-base text-left text-gray-500
                "
              >
                4,2857.71 BGBB
              </th>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-center text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-calendar-alt text-base"> </i> 209 DAYS
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-clock text-base"> </i>
                  #4
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="fas fa-user-plus text-base"> </i>
                  0x000...000000
                </p>
              </td>

              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right
                "
              >
                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-bgbb-y
                    text-sm
                  "
                >
                  Adjust Stake
                </a>

                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-dark-bgbb100
                    text-sm
                  "
                >
                  Remove Stake
                </a>
              </td>
            </tr>

            <tr>
              <th
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  whitespace-no-wrap
                  p-4
                  text-base text-left text-gray-500
                "
              >
                4,2857.71 BGBB
              </th>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-center text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-calendar-alt text-base"> </i> 261 DAYS
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-clock text-base"> </i>
                  #5
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="fas fa-user-plus text-base"> </i>
                  0x000...000000
                </p>
              </td>

              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right
                "
              >
                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-bgbb-y
                    text-sm
                  "
                >
                  Adjust Stake
                </a>

                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-dark-bgbb100
                    text-sm
                  "
                >
                  Remove Stake
                </a>
              </td>
            </tr>

            <tr>
              <th
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  whitespace-no-wrap
                  p-4
                  text-base text-left text-gray-500
                "
              >
                4,2857.71 BGBB
              </th>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-center text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-calendar-alt text-base"> </i> 313 DAYS
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-clock text-base"> </i>
                  #6
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="fas fa-user-plus text-base"> </i>
                  0x000...000000
                </p>
              </td>

              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right
                "
              >
                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-bgbb-y
                    text-sm
                  "
                >
                  Adjust Stake
                </a>

                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-dark-bgbb100
                    text-sm
                  "
                >
                  Remove Stake
                </a>
              </td>
            </tr>

            <tr>
              <th
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  whitespace-no-wrap
                  p-4
                  text-base text-left text-gray-500
                "
              >
                4,2857.71 BGBB
              </th>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-center text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-calendar-alt text-base"> </i> 365 DAYS
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-clock text-base"> </i>
                  #7
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="fas fa-user-plus text-base"> </i>
                  0x000...000000
                </p>
              </td>

              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right
                "
              >
                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-bgbb-y
                    text-sm
                  "
                >
                  Adjust Stake
                </a>

                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-dark-bgbb100
                    text-sm
                  "
                >
                  Remove Stake
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="flex flex-wrap text-center justify-center mt-8">
        <a
          href="#"
          target="_self"
          class="
            mb-6
            font-semibold
            text-white
            px-6
            py-4
            rounded
            outline-none
            focus:outline-none
            bg-dark-bgbb100
            text-sm
            container2
          "
        >
          Create 7 Regular Stakes
        </a>
      </div>
    </div>
    <!-- ============= END 7 STAKES ======================= -->

    <!-- ============= BEGIN 8 STAKES ======================= -->
    <div v-bind:class="{ hidden: openTab !== 7, block: openTab === 7 }">
      <div class="block w-full overflow-x-auto">
        <!-- Projects table -->
        <table class="items-center w-full bg-transparent border-collapse">
          <br />
          <p class="text-center">Create your ultimate staking strategy</p>
          <br />

          <tbody>
            <tr>
              <th
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  whitespace-no-wrap
                  p-4
                  text-base text-left text-gray-500
                "
              >
                3,7500.00 BGBB
              </th>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-center text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-calendar-alt text-base"> </i> 50 DAYS
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-clock text-base"> </i>
                  #1
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="fas fa-user-plus text-base"> </i>
                  0x000...000000
                </p>
              </td>

              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right
                "
              >
                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-bgbb-y
                    text-sm
                  "
                >
                  Adjust Stake
                </a>

                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-dark-bgbb100
                    text-sm
                  "
                >
                  Remove Stake
                </a>
              </td>
            </tr>

            <tr>
              <th
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  whitespace-no-wrap
                  p-4
                  text-base text-left text-gray-500
                "
              >
                3,7500.00 BGBB
              </th>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-center text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-calendar-alt text-base"> </i> 95 DAYS
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-clock text-base"> </i>
                  #2
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="fas fa-user-plus text-base"> </i>
                  0x000...000000
                </p>
              </td>

              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right
                "
              >
                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-bgbb-y
                    text-sm
                  "
                >
                  Adjust Stake
                </a>

                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-dark-bgbb100
                    text-sm
                  "
                >
                  Remove Stake
                </a>
              </td>
            </tr>

            <tr>
              <th
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  whitespace-no-wrap
                  p-4
                  text-base text-left text-gray-500
                "
              >
                3,7500.00 BGBB
              </th>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-center text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-calendar-alt text-base"> </i> 140 DAYS
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-clock text-base"> </i>
                  #3
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="fas fa-user-plus text-base"> </i>
                  0x000...000000
                </p>
              </td>

              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right
                "
              >
                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-bgbb-y
                    text-sm
                  "
                >
                  Adjust Stake
                </a>

                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-dark-bgbb100
                    text-sm
                  "
                >
                  Remove Stake
                </a>
              </td>
            </tr>

            <tr>
              <th
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  whitespace-no-wrap
                  p-4
                  text-base text-left text-gray-500
                "
              >
                3,7500.00 BGBB
              </th>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-center text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-calendar-alt text-base"> </i> 185 DAYS
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-clock text-base"> </i>
                  #4
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="fas fa-user-plus text-base"> </i>
                  0x000...000000
                </p>
              </td>

              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right
                "
              >
                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-bgbb-y
                    text-sm
                  "
                >
                  Adjust Stake
                </a>

                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-dark-bgbb100
                    text-sm
                  "
                >
                  Remove Stake
                </a>
              </td>
            </tr>

            <tr>
              <th
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  whitespace-no-wrap
                  p-4
                  text-base text-left text-gray-500
                "
              >
                3,7500.00 BGBB
              </th>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-center text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-calendar-alt text-base"> </i> 230 DAYS
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-clock text-base"> </i>
                  #5
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="fas fa-user-plus text-base"> </i>
                  0x000...000000
                </p>
              </td>

              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right
                "
              >
                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-bgbb-y
                    text-sm
                  "
                >
                  Adjust Stake
                </a>

                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-dark-bgbb100
                    text-sm
                  "
                >
                  Remove Stake
                </a>
              </td>
            </tr>

            <tr>
              <th
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  whitespace-no-wrap
                  p-4
                  text-base text-left text-gray-500
                "
              >
                3,7500.00 BGBB
              </th>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-center text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-calendar-alt text-base"> </i> 275 DAYS
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-clock text-base"> </i>
                  #6
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="fas fa-user-plus text-base"> </i>
                  0x000...000000
                </p>
              </td>

              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right
                "
              >
                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-bgbb-y
                    text-sm
                  "
                >
                  Adjust Stake
                </a>

                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-dark-bgbb100
                    text-sm
                  "
                >
                  Remove Stake
                </a>
              </td>
            </tr>

            <tr>
              <th
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  whitespace-no-wrap
                  p-4
                  text-base text-left text-gray-500
                "
              >
                3,7500.00 BGBB
              </th>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-center text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-calendar-alt text-base"> </i> 320 DAYS
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-clock text-base"> </i>
                  #7
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="fas fa-user-plus text-base"> </i>
                  0x000...000000
                </p>
              </td>

              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right
                "
              >
                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-bgbb-y
                    text-sm
                  "
                >
                  Adjust Stake
                </a>

                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-dark-bgbb100
                    text-sm
                  "
                >
                  Remove Stake
                </a>
              </td>
            </tr>

            <tr>
              <th
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  whitespace-no-wrap
                  p-4
                  text-base text-left text-gray-500
                "
              >
                3,7500.00 BGBB
              </th>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-center text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-calendar-alt text-base"> </i> 365 DAYS
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-clock text-base"> </i>
                  #8
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="fas fa-user-plus text-base"> </i>
                  0x000...000000
                </p>
              </td>

              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right
                "
              >
                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-bgbb-y
                    text-sm
                  "
                >
                  Adjust Stake
                </a>

                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-dark-bgbb100
                    text-sm
                  "
                >
                  Remove Stake
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="flex flex-wrap text-center justify-center mt-8">
        <a
          href="#"
          target="_self"
          class="
            mb-6
            font-semibold
            text-white
            px-6
            py-4
            rounded
            outline-none
            focus:outline-none
            bg-dark-bgbb100
            text-sm
            container2
          "
        >
          Create 8 Regular Stakes
        </a>
      </div>
    </div>
    <!-- ============= END 8 STAKES ======================= -->

    <!-- ============= BEGIN 9 STAKES ======================= -->
    <div v-bind:class="{ hidden: openTab !== 8, block: openTab === 8 }">
      <div class="block w-full overflow-x-auto">
        <!-- Projects table -->
        <table class="items-center w-full bg-transparent border-collapse">
          <br />
          <p class="text-center">Create your ultimate staking strategy</p>
          <br />

          <tbody>
            <tr>
              <th
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  whitespace-no-wrap
                  p-4
                  text-base text-left text-gray-500
                "
              >
                3,333.33 BGBB
              </th>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-center text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-calendar-alt text-base"> </i> 45 DAYS
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-clock text-base"> </i>
                  #1
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="fas fa-user-plus text-base"> </i>
                  0x000...000000
                </p>
              </td>

              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right
                "
              >
                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-bgbb-y
                    text-sm
                  "
                >
                  Adjust Stake
                </a>

                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-dark-bgbb100
                    text-sm
                  "
                >
                  Remove Stake
                </a>
              </td>
            </tr>

            <tr>
              <th
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  whitespace-no-wrap
                  p-4
                  text-base text-left text-gray-500
                "
              >
                3,333.33 BGBB
              </th>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-center text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-calendar-alt text-base"> </i> 85 DAYS
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-clock text-base"> </i>
                  #2
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="fas fa-user-plus text-base"> </i>
                  0x000...000000
                </p>
              </td>

              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right
                "
              >
                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-bgbb-y
                    text-sm
                  "
                >
                  Adjust Stake
                </a>

                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-dark-bgbb100
                    text-sm
                  "
                >
                  Remove Stake
                </a>
              </td>
            </tr>

            <tr>
              <th
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  whitespace-no-wrap
                  p-4
                  text-base text-left text-gray-500
                "
              >
                3,333.33 BGBB
              </th>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-center text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-calendar-alt text-base"> </i> 125 DAYS
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-clock text-base"> </i>
                  #3
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="fas fa-user-plus text-base"> </i>
                  0x000...000000
                </p>
              </td>

              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right
                "
              >
                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-bgbb-y
                    text-sm
                  "
                >
                  Adjust Stake
                </a>

                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-dark-bgbb100
                    text-sm
                  "
                >
                  Remove Stake
                </a>
              </td>
            </tr>

            <tr>
              <th
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  whitespace-no-wrap
                  p-4
                  text-base text-left text-gray-500
                "
              >
                3,333.33 BGBB
              </th>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-center text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-calendar-alt text-base"> </i> 165 DAYS
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-clock text-base"> </i>
                  #4
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="fas fa-user-plus text-base"> </i>
                  0x000...000000
                </p>
              </td>

              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right
                "
              >
                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-bgbb-y
                    text-sm
                  "
                >
                  Adjust Stake
                </a>

                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-dark-bgbb100
                    text-sm
                  "
                >
                  Remove Stake
                </a>
              </td>
            </tr>

            <tr>
              <th
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  whitespace-no-wrap
                  p-4
                  text-base text-left text-gray-500
                "
              >
                3,333.33 BGBB
              </th>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-center text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-calendar-alt text-base"> </i> 205 DAYS
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-clock text-base"> </i>
                  #5
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="fas fa-user-plus text-base"> </i>
                  0x000...000000
                </p>
              </td>

              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right
                "
              >
                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-bgbb-y
                    text-sm
                  "
                >
                  Adjust Stake
                </a>

                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-dark-bgbb100
                    text-sm
                  "
                >
                  Remove Stake
                </a>
              </td>
            </tr>

            <tr>
              <th
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  whitespace-no-wrap
                  p-4
                  text-base text-left text-gray-500
                "
              >
                3,333.33 BGBB
              </th>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-center text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-calendar-alt text-base"> </i> 245 DAYS
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-clock text-base"> </i>
                  #6
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="fas fa-user-plus text-base"> </i>
                  0x000...000000
                </p>
              </td>

              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right
                "
              >
                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-bgbb-y
                    text-sm
                  "
                >
                  Adjust Stake
                </a>

                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-dark-bgbb100
                    text-sm
                  "
                >
                  Remove Stake
                </a>
              </td>
            </tr>

            <tr>
              <th
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  whitespace-no-wrap
                  p-4
                  text-base text-left text-gray-500
                "
              >
                3,333.33 BGBB
              </th>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-center text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-calendar-alt text-base"> </i> 285 DAYS
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-clock text-base"> </i>
                  #7
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="fas fa-user-plus text-base"> </i>
                  0x000...000000
                </p>
              </td>

              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right
                "
              >
                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-bgbb-y
                    text-sm
                  "
                >
                  Adjust Stake
                </a>

                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-dark-bgbb100
                    text-sm
                  "
                >
                  Remove Stake
                </a>
              </td>
            </tr>

            <tr>
              <th
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  whitespace-no-wrap
                  p-4
                  text-base text-left text-gray-500
                "
              >
                3,333.33 BGBB
              </th>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-center text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-calendar-alt text-base"> </i> 325 DAYS
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-clock text-base"> </i>
                  #8
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="fas fa-user-plus text-base"> </i>
                  0x000...000000
                </p>
              </td>

              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right
                "
              >
                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-bgbb-y
                    text-sm
                  "
                >
                  Adjust Stake
                </a>

                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-dark-bgbb100
                    text-sm
                  "
                >
                  Remove Stake
                </a>
              </td>
            </tr>

            <tr>
              <th
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  whitespace-no-wrap
                  p-4
                  text-base text-left text-gray-500
                "
              >
                3,333.33 BGBB
              </th>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-center text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-calendar-alt text-base"> </i> 365 DAYS
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="far fa-clock text-base"> </i>
                  #9
                </p>
              </td>
              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right text-gray-500
                "
              >
                <p class="text-base">
                  <i class="fas fa-user-plus text-base"> </i>
                  0x000...000000
                </p>
              </td>

              <td
                class="
                  border-t border-b
                  px-6
                  align-middle
                  border-l border-r
                  text-xs
                  whitespace-no-wrap
                  p-4
                  text-right
                "
              >
                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-bgbb-y
                    text-sm
                  "
                >
                  Adjust Stake
                </a>

                <a
                  href="#"
                  target="_self"
                  class="
                    get-started
                    font-semibol
                    text-white
                    px-4
                    py-2
                    rounded
                    outline-none
                    mr-1
                    mb-1
                    bg-dark-bgbb100
                    text-sm
                  "
                >
                  Remove Stake
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="flex flex-wrap text-center justify-center mt-8">
        <a
          href="#"
          target="_self"
          class="
            mb-6
            font-semibold
            text-white
            px-6
            py-4
            rounded
            outline-none
            focus:outline-none
            bg-dark-bgbb100
            text-sm
            container2
          "
        >
          Create 9 Regular Stakes
        </a>
      </div>
    </div>
    <!-- ============= END 9 STAKES ======================= -->
  </div>
</template>


<script>
export default {
  name: "emerald-tabs",
  data() {
    return {
      openTab: 1,
    };
  },
  methods: {
    toggleTabs: function (tabNumber) {
      this.openTab = tabNumber;
    },
  },
};
</script>